// 用于组件传值
import mitt from "mitt";
export default new mitt();